module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profile.confirmed),
      expression: "!profile.confirmed"
    }],
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Подтверждение электронной почты\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Для продолжения работы с системой Вам необходимо ввести код подтверждения, код был послан на адрес электронной почты " + _vm._s(_vm.profile.email) + ".\n          "), _c('v-text-field', {
    attrs: {
      "label": "Код подтверждения",
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.confirmationCode),
      callback: function($$v) {
        _vm.confirmationCode = $$v
      },
      expression: "confirmationCode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": _vm.confirmEmail
    }
  }, [_vm._v("Подтвердить")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": '100%'
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Обо мне\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPersonAgreement),
      expression: "isNeedPersonAgreement"
    }]
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPersonAgreement),
      expression: "isNeedPersonAgreement"
    }],
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных"
    },
    model: {
      value: (_vm.needPersonAgreementCheck),
      callback: function($$v) {
        _vm.needPersonAgreementCheck = $$v
      },
      expression: "needPersonAgreementCheck"
    }
  })], 1), _vm._v(" "), _c('v-form', {
    ref: "profile",
    model: {
      value: (_vm.profileValid),
      callback: function($$v) {
        _vm.profileValid = $$v
      },
      expression: "profileValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "value": _vm.profile.lastName,
      "label": "Фамилия",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "firstName",
      "value": _vm.profile.firstName,
      "label": "Имя",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "middleName",
      "value": _vm.profile.middleName,
      "label": "Отчество",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "phone",
      "value": _vm.profile.phone,
      "rules": _vm.phoneRules,
      "label": "Тел. личный",
      "type": "text",
      "clearable": ""
    }
  })], 1), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editProfile),
      expression: "editProfile"
    }],
    attrs: {
      "hide-details": "",
      "label": "Изменить параметры входа"
    },
    model: {
      value: (_vm.needCredentials),
      callback: function($$v) {
        _vm.needCredentials = $$v
      },
      expression: "needCredentials"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": !_vm.needCredentials,
      "name": "email",
      "value": _vm.profile.email,
      "label": "Эл. почта",
      "type": "text",
      "rules": _vm.emailRules,
      "clearable": _vm.needCredentials
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCredentials && _vm.editProfile),
      expression: "needCredentials && editProfile"
    }],
    ref: "newPassword",
    attrs: {
      "type": "password",
      "label": "Пароль",
      "rules": _vm.passwordRules,
      "clearable": _vm.needCredentials
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCredentials && _vm.editProfile),
      expression: "needCredentials && editProfile"
    }],
    ref: "retype",
    attrs: {
      "error-messages": _vm.errorRetype(),
      "type": "password",
      "label": "Подтверждение",
      "hint": "Подтвердите пароль",
      "clearable": _vm.needCredentials
    },
    model: {
      value: (_vm.retype),
      callback: function($$v) {
        _vm.retype = $$v
      },
      expression: "retype"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editProfile),
      expression: "editProfile"
    }],
    attrs: {
      "disabled": _vm.isNeedPersonAgreement && !_vm.needPersonAgreementCheck
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editProfile),
      expression: "!editProfile"
    }],
    on: {
      "click": function($event) {
        _vm.editProfile = true
      }
    }
  }, [_vm._v("Изменить")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "height": _vm.calcHeight()
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Мои компании\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.accountClients), function(item) {
    return [_c('v-flex', [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(item.clientNameShort))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isCurrentClient(item)),
        expression: "isCurrentClient(item)"
      }]
    }, [_vm._v("done")])], 1), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v("Эл. почта компании: "), _c('b', [_vm._v(_vm._s(item.clientEmail))])]), _vm._v(" "), _c('div', [_vm._v("Тел. рабочий: "), _c('b', [_vm._v(_vm._s(item.clientPhone))])]), _vm._v(" "), _c('div', [_vm._v("Полномочия: "), _c('b', [_vm._v(_vm._s(item.roleNotes))])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isCurrentClient(item)),
        expression: "!isCurrentClient(item)"
      }],
      on: {
        "click": function($event) {
          return _vm.setCurrentClient(item)
        }
      }
    }, [_vm._v("Сделать текущей")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f24edb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Profile.vue
// module id = 995
// module chunks = 1